import { render, staticRenderFns } from "./StepEdit.vue?vue&type=template&id=1bc1d071&scoped=true"
import script from "./StepEdit.vue?vue&type=script&lang=js"
export * from "./StepEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc1d071",
  null
  
)

export default component.exports